"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWcmmode = exports.getMeta = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/**
 * Returns the property of the meta tag value given as an argument
 * @param {string} metaName - Meta attribute which we want to get its value
 */
var getMeta = function getMeta(metaName) {
  if (typeof window !== 'undefined') {
    var _iframeEditable$conte;
    var iframeEditable = document.getElementById('ContentFrame');
    var doc = (iframeEditable === null || iframeEditable === void 0 ? void 0 : (_iframeEditable$conte = iframeEditable.contentWindow) === null || _iframeEditable$conte === void 0 ? void 0 : _iframeEditable$conte.document) || document;
    var listMetaTags = (0, _toConsumableArray2.default)(doc.getElementsByTagName('meta'));
    var meta = listMetaTags.find(function (el) {
      return el.getAttribute('property') === metaName;
    });
    if (meta) {
      return meta.getAttribute('content');
    }
  }
  return '';
};

/**
 * Returns string with value inside meta tag cq:wcmmode, edit / preview
 */
exports.getMeta = getMeta;
var getWcmmode = function getWcmmode() {
  return getMeta('cq:wcmmode');
};
exports.getWcmmode = getWcmmode;